import React from 'react';

/** @typedef {import('types/app').InnerHtmlProps} InnerHtmlProps */

/**
 * @param {InnerHtmlProps} props
 */
const FPHtmlViewer = ({ content, ...rest }) => {
  return (
    <div
      data-testid="content-viewer"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: content
      }}
      {...rest}
    />
  );
};

FPHtmlViewer.defaultProps = {};

export default FPHtmlViewer;
